import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import bgimage from '../../../../images/items/default_item.png';
import { Button } from 'react-bootstrap'; 
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import swal from "sweetalert2";
import axios from 'axios'; // new
// import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';

const AddItem = () => {

    const options_units = [
        { value: "", label: "Select Units" },
        { value: "1", label: "gms" },
        { value: "2", label: "Kg's" },
        { value: "3", label: "Ltr's" },
        { value: "4", label: "ton's" },
        { value: "5", label: "No's" },
    ];
    const gravy = [  
        { value: "0", label: "Idly" },
        { value: "1", label: "Puttu" },
    ];
    const soup = [
        { value: "0", label: "Dosai" },
        { value: "1", label: "Uthappam" },
    ];
    const groupedOptions_items = [
        {
            label: "Steamed Food",
            options: gravy,

        },
        {
            label: "Rice Based Food",
            options: soup,
        },
    ];

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };

    const [selectedOption, setSelectedOption] = useState(null);


    const [file, setFile] = React.useState(null)
    const imageInputRef = useRef(null);
    const fileHandler = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    }

    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

    const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);
    // Add new IP configuration
    const handleAddConfig = () => {
        setRawMatrial([...rawMatrial, { id: Date.now() }]);
    };

    // Delete an IP configuration
    const handleDeleteConfig = (id) => {
        setRawMatrial(rawMatrial.filter(config => config.id !== id));
    };

    const rice_shop = [
        { value: "0", label: "Basmathi Rice" },
        { value: "1", label: "Ponni Rice" },
    ];
    const pulses = [
        { value: "0", label: "Urad Dal" },
        { value: "1", label: "Chana Dal" },
        { value: "2", label: "Fenugreek" },
    ];
    const salt = [
        { value: "0", label: "Rock Salt" },
        { value: "1", label: "Normal Salt" },
    ];
    const spices = [
        { value: "0", label: "Red Chilli Powder" },
        { value: "1", label: "Cumin Seed" },
    ];
    const nuts = [
        { value: "0", label: "Black Seasame Seed" },
    ];
    const g_spcies = [
        { value: "0", label: "Hing" },
    ];
    const oil = [
        { value: "0", label: "Refined Oil" },
        { value: "1", label: "Sunflower Oil" },
        { value: "2", label: "Refinded Coconut Oil" },
    ];
    const groupedOptions_raw_material = [
        {
            label: "Grains - Rice",
            options: rice_shop,
        },
        {
            label: "Grains - Pulses",
            options: pulses,
        },
        {
            label: "Seasoning - Salt",
            options: salt,
        },
        {
            label: "Spices - Whole Spices",
            options: spices,
        },
        {
            label: "Nuts - Seed",
            options: nuts,
        },
        {
            label: "Spices - Ground Spices",
            options: g_spcies,
        },
        {
            label: "Liquid - Oil",
            options: oil,
        },
    ];
    const ConfirmationModal = () => {
        swal.fire({
            html: `
                <div class="alert alert-success px-2 py-2" role="alert">
                    Are You Sure Want to Create Item
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>Podi Idly</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" 
                    // viewBox="0 0 48 48" width="48" height="48">
                    // <defs>
                    // <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
                    // </style></defs>
                    // <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                    // <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
                    // <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
                    // <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
                    // <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
                    // <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
                    // <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
                    // </svg>
                </div>
                          `,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                swal.fire({
                    title: 'Item Created Successfully!',
                    text: `Podi Idly`,
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(() => {
                    window.location.href = './manage-items';
                });
            } else {
                swal.fire({
                    title: 'Creation Process Cancelled',
                    text: `Idly`,
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            }
        });
    };
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#228b22' }}>Add Items</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Package Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-items'>Manage Items</Link></li>
                    </ol>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Item Category / Sub category<span className="required">*</span></label>
                    <Select placeholder="Select Item Category & Sub Category"
                        defaultValue={selectedOption}
                        options={groupedOptions_items}
                        components={{ Group }}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Item Name<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Item Name" />
                </div>
                <div className='col-lg-2 mb-4'>
                    <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Quantity" />
                </div>
                <div className='col-lg-2 mb-4'>
                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                    <Select placeholder="Select Units"
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_units}

                    />
                </div>
                <div className="col-lg-8 mb-4">
                    <label className="text-black font-w500 fs-7">Description</label>
                    <textarea className="form-control mt-2" placeholder="Description" />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Item Image</label>
                    <div className="avatar-upload d-flex align-items-center">
                        <div className="change position-relative px-0">
                            <div className="avatar-preview h-100px w-100px border" style={{ borderRadius: '10px' }}>
                                <img
                                    id="saveImageFile"
                                    src={file ? URL.createObjectURL(file) : bgimage}
                                    alt={file ? file.name : 'Default Avatar'}
                                    className="p-1 h-100px w-100px"
                                />
                            </div>
                            <div className="change-btn">
                                <input
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={fileHandler}
                                    ref={imageInputRef}
                                />
                                <div className="mt-2 d-flex justify-content-center gap-3">
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="success"
                                        onClick={() => imageInputRef.current.click()}
                                    >
                                        <span className="">
                                            <i className="fa fa-upload color-success fs-4" />
                                        </span>
                                    </Button>
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="danger"
                                        onClick={RemoveImage}
                                    >
                                        <span className="">
                                            <i className="fa fa-close color-danger fs-4" />
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-lg-12 mb-4">
                    <label className="fs-3 text-black font-w500">
                        Raw Material
                    </label>
                </div>
                <div className="col-lg-12 mb-3">
                    <div className="mb-0">
                        {rawMatrial.map(config => (
                            <div key={config.id} data-repeater-item>
                                <div className="row">
                                    <div className="col-lg-7 mb-4">
                                        <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                                        <Select placeholder="Select Raw Material"
                                            defaultValue={selectedOption}
                                            options={groupedOptions_raw_material}
                                            components={{ Group }}
                                            styles={customStyles}
                                            menuPlacement='top'
                                            menuPosition='absolute'
                                        />
                                    </div>
                                    <div className='col-lg-2'>
                                        <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Quantity" />
                                    </div>
                                    <div className='col-lg-2'>
                                        <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                        <Select placeholder='Units'
                                            defaultValue={selectedOption}
                                            onChange={setSelectedOption}
                                            options={options_units}
                                            menuPlacement='top'
                                            menuPosition='absolute'
                                        />
                                    </div>
                                    <div className="col-lg-1 mb-1 px-1 py-1">
                                        {rawMatrial.length > 1 && (
                                            <button
                                                className="btn btn-danger mt-4 px-2 py-2"
                                                onClick={() => handleDeleteConfig(config.id)}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Delete"
                                            >
                                                <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="mb-1 mt-1">
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={handleAddConfig}
                        >
                            <span><i className="fa-solid fa-plus fs-6"></i></span>
                            <span className='ms-2 fs-7'>Add More</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-lg-12 mb-4">
                    <label className="fs-3 text-black font-w500">
                        Receipe Notes
                    </label>
                </div>
                <div className="col-lg-12 mb-3">
                    <div className="custom-ekeditor">
                        <CKEditor
                            editor={ClassicEditor}
                            config={{
                                toolbar: [
                                    'heading', 'bold', 'italic', '|', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'
                                ]
                            }}
                            onReady={editor => {
                                console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                            }}
                            onBlur={(event, editor) => {
                                console.log('Blur.', editor);
                            }}
                            onFocus={(event, editor) => {
                                console.log('Focus.', editor);
                            }}
                        />
                    </div>
                </div>

            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-items'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                <Link to={'#'} onClick={ConfirmationModal} type="submit" className="btn btn-sm btn-primary">Create Items</Link>
            </div>
        </>
    ) 


}
export default AddItem;